import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Injector,
    Input,
    OnChanges,
    SimpleChanges,
    ViewEncapsulation,
} from '@angular/core';
import { IOwnershipArea, IOwnershipUser } from '@fi-app/other-settings/transfer-ownership/fi-transfer-ownership';
import { AbstractControl, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors } from '@angular/forms';
import { ControlValueAccessorValidatorBase } from '@fi-shared/control-value-accessor-validator-base';
import { isDefined } from '@fi-shared/utils';
import { FiDropdownItemDisabledFn } from '@fi-shared/fi-select-search/fi-select-search';
import { FiTransferOwnershipService } from '@fi-app/other-settings/transfer-ownership/fi-transfer-ownership.service';

@Component({
    selector: 'fi-transfer-ownership-to-card',
    templateUrl: './fi-transfer-ownership-to-card.component.html',
    styleUrl: './fi-transfer-ownership-to-card.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-transfer-ownership-to-card' },
    standalone: false,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: FiTransferOwnershipToCardComponent,
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: FiTransferOwnershipToCardComponent,
        },
    ],
})
export class FiTransferOwnershipToCardComponent
    extends ControlValueAccessorValidatorBase<IOwnershipUser>
    implements OnChanges
{
    @Input({ required: true }) sourceUser: IOwnershipUser;
    @Input({ required: true }) toAreas: IOwnershipArea[];
    @Input() isDisabled: boolean;
    @Input() disabledUserIdsByShareRights: number[];

    constructor(
        injector: Injector,
        private fiTransferOwnershipService: FiTransferOwnershipService,
    ) {
        super(injector);
    }

    ngOnChanges(changes: SimpleChanges): void {
        const change = changes.sourceUser;
        if (change) {
            if (change.currentValue) {
                // if new 'from user' selected - clear selection in 'to user' dropdown
                this.ngModel = undefined;
                this.doPropagateChanges();
                this.fiTransferOwnershipService
                    .getDisabledUserIdsByShareRights(this.sourceUser.Id)
                    .then((disabledUserIds) => {
                        this.disabledUserIdsByShareRights = disabledUserIds;
                    });
            } else {
                this.disabledUserIdsByShareRights = [];
            }
        }
    }

    doValidate(c: AbstractControl): ValidationErrors {
        return {
            required: !isDefined(this.ngModel),
        };
    }

    isUserDisabledFn: FiDropdownItemDisabledFn<IOwnershipUser> = (item: IOwnershipUser, allItems: IOwnershipUser[]) => {
        if (item.IsDisabled) return true;
        if (this.sourceUser) {
            const isDisabled = item.Id === this.sourceUser.Id || this.disabledUserIdsByShareRights.includes(item.Id);
            return isDisabled;
        }
        return false;
    };
}
